<div class="user">
    <span class="radio c-radio">
        <label style="display: block;">
            <input (change)="radioChanged($event)" type="radio" name="Users" checked="checked" id="radio-mini-1" value="all">
            <span class="fa fa-circle"></span>{{bs.getResource('rbkey_AllLBL')}}
        </label>
        <label style="display: block;">
            <input (change)="radioChanged($event)" type="radio" name="Users" id="radio-mini-2" value="selectUser">
            <!-- <span class="fa fa-circle"></span>Select User <span style="color: #5d9cec">Refresh User List</span> -->
            <span class="fa fa-circle"></span> {{bs.getResource('rbkey_brfc_ShrSpcfcLbl')}}
        </label>
    </span>
</div>
<div *ngIf="selectUserList" id="rootTreeUser">
    <div class="learning-heading-section cCustom">
        <div class="learning-title">
            <span class="rows">{{bs.getResource('rbkey_UsrsClnLBL')}}</span>
            <span class="bottom-line"></span>
        </div>
        <div class="pull-right margin_top4">
            <!-- <div class="btn-group mb-sm border-right margin_right10">
                <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle text-link">
                    <img src="assets/img/arrows.svg" style="width: 14px; height: 17px;" alt="">
                    <span>By </span>Ascending
                    <span class="caret"></span>
                </a>
                <ul role="menu" class="dropdown-menu animated fadeIn right">
                    <li><a (click)="sort('A')" href="javascript:void(0);">Ascending</a>
                    </li>
                    <li><a (click)="sort('D')" href="javascript:void(0);">Descending</a>
                    </li>
                </ul>
            </div> -->
            <a href="javascript:void(0);" (click)="toggleSearch()" class="search-icon-heading icon-magnifier pull-right cUser"></a>
            <form role="search" class="search-form hide animated fadeInLeft cSearch" id="SearchForm">
                <div class="form-group has-feedback no-margin-b">
                    <input #searchBox (keyup)="search(searchBox.value.toLowerCase())" id="searchText" type="text" placeholder="{{bs.getResource('rbkey_srchLBLplchldr')}}" 
                        class="form-control" (keydown)="keyDownFunction($event)">
                    <div (click)="toggleSearch()" class="fa fa-times form-control-feedback remove-search cRsearch cross-position"></div>
                </div>
                <!-- <button type="submit" class="hidden btn btn-default">Submit</button> -->
            </form>
        </div>
    </div>
    <div class="chips-box">
        <div class="chips" *ngFor="let obj of UserIdList" id="chips{{obj['id']}}">
            <div class="chips-list" id="{{obj['id']}}"> {{obj['uName']}}
                <i class="close fa fa-times" id="{{obj['id']}}" (click)="toggleChips(obj['id'])"></i>
            </div>
        </div>
    </div>
    <div class="rows learning-list-table cListTable">
        <div id="courses" role="tabpanel" class="tab-pane fade show active cActive">
            <div class="leaderboard-tab-inner">
                <table class="custom-table" id="custom-table">
                    <tbody>
                        <tr *ngFor="let obj of uData | async; let i=index;">
                            <div class="checkbox c-checkbox" id="checkboxes">
                                <label class="needsclick">
                                    <input type="checkbox" name="Response" id="user{{obj['UserId']}}" value="{{obj['UserId']}}" (click)="selectTag(obj['UserId'],obj['UserName'])">
                                    <span class="fa fa-check"></span>
                                    <div class="ans-img">
                                        <div class="rows">
                                            {{obj['UserName']}}
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- <div class="tagcloud02" *ngIf="false">
			<ul>
				<ng-container *ngFor="let obj of dummyData; let i=index;">
					<!-- <div *ngIf="i%10 == 0" class="headings">MMMM</div> -->
        <!-- <li (click)="selectTag(i)">
						<a href="javascript:void(0);" id="tags{{i}}">{{i}} First idea for improvement</a>
					</li>
				</ng-container>
			</ul>
		</div>
    </div> -->
    </div>